import styled from 'styled-components';

export const ResourcesStepsOneExamplesWrapper = styled.div`
  width: 100%;
  max-width: 956px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
`;

export const ResourcesStepsOneExamplesTitle = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  color: #000;
`;

export const ResourcesStepsOneExamplesList = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px 5px;

  flex-wrap: wrap;
`;

export const ResourcesStepsOneExamplesItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;

  padding: 4px 8px;

  border-radius: 26px;
  border: 1px solid #323f5d;

  cursor: pointer;
`;

export const ResourcesStepsOneExamplesItemTitle = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;

  color: #323f5d;
`;
